import { StationOrder } from '../types/station-journey';
import HttpHelpers from './helpers';
import formatResponse from './utils';

type FormattedOrderResponse = {
  result: StationOrder;
};

const OrdersApiEndpoints = {
  createStationDispatch: (
    stationCode: string,
    idempotencyKey: string,
  ): Promise<FormattedOrderResponse> => HttpHelpers.authenticatedAxios
    .post(
      '/api/v1/orders',
      {
        station_id: stationCode,
        source: 'web_station_qr',
      },
      {
        headers: {
          'Idempotency-Key': idempotencyKey,
        },
      },
    )
    .then((response) => formatResponse(response.data)),

  getOrder: (orderId: string): Promise<FormattedOrderResponse> => (
    HttpHelpers.authenticatedAxios
      .get(`/api/v1/orders/${encodeURIComponent(orderId)}`)
      .then((response) => formatResponse(response.data))
  ),
};

export default OrdersApiEndpoints;
